import React, { Component, PropTypes } from 'react'
import $ from 'jquery'
import { Link } from 'react-router'
import Parallax from '../Parallax'

import BottomNavigation from './../BottomNavigation'
import PerformanceList from './PerformanceList'
import { ROUTE_CONTACT, ROUTE_HOME, ROUTE_PERFORMANCES } from '../../constants'

/*eslint-disable no-script-url*/
class Introduction extends Component {

  launchPlayer() {
    const { setShowPlayer } = this.props
    setShowPlayer(true)
    $('.modal').modal({ opacity: 0, dismissible: false })
    $('#modalPlaylist').modal('open')
  }

  render() {
    return (
      <div>

        <Parallax image="introduction" alt="Introduction" title="Présentation"/>

        <div className="row content section white">
          <div className="col s12">
            <div className="">
              <span className="content-title">Présentage</span>


              <p className="justify">La fanfare <b>Mouv' your Baudet</b> est une fanfare "de vieux" de <b>Poitiers</b>.
                Elle est composée de <b>15 fanfarons</b> expérimentés, issus de multiples parcours (18 trous), et
                évoluant
                à différents pupitres : <b>trompette</b>, <b>trombone</b>, <b>tuba basse</b>, <b>soubassophone</b>,
                et <b>percu</b> (grosse
                caisse, caisse claire, et occasionnellement bongo).
                La fanfare fête cette année ses <b>{new Date().getFullYear() - 2009} ans</b> d'existence.
                <br/><br/>
                Le
                <a href="javascript:void(0)" onClick={() => this.launchPlayer()}> répertoire musical</a> Mouv' your
                Baudet
                est très varié. Il est inspiré de la <b>variété française et internationale</b> (voire extra-terrestre),
                des années 50 à nos jours.<br/><br/>
                On y retrouve divers styles musicaux
                : <b>disco</b>, <b>pop</b>, <b>dance</b>, <b>techno</b>, <b>ska</b>, <b>rock</b>, <b>metal</b>, <b>bal
                  musette</b> et bien d'autres encore...
                <br/>
                <br/>
                La fanfare Mouv' your Baudet, c'est <b>15 musiciens</b> au taquet pour <b>animer</b> POUR VOUS tout type
                de
                <Link to={ROUTE_PERFORMANCES}> prestation</Link> :<br/>

              </p>

              <PerformanceList/>


              <p className="justify">
                Alors, n'hésitez plus, <Link to={ROUTE_CONTACT}> contactez le Président !</Link>
              </p>

            </div>

          </div>
        </div>

        <Parallax image="performances" alt="Prestations"/>

        <div className="row content section">
          <div className="col s12">
            <div className="">
              <span className="content-title">Témoignages</span>


              <p className="justify">SUPER SOIRÉE BOJO 2015 !<br/><br/>
                Des témoins témoignent en témoignant :</p>
              <div className="card">
                <div className="card-content"><span className="bq">"Avec Robert, mon époux, nous avons fait l'amour toute la nuit, grâce à la fanfare Mouv' your Baudet."</span>
                  <span className="author"> (Ginette, 85 ans, retraitée)</span></div>
              </div>
              <div className="card">
                <div className="card-content"><span className="bq">"Je détestais le vin et là, ça a été une révélation, je ne bois plus que du beaujolais."</span>
                  <span className="author"> (Ahmadinejad, Président factuel)</span></div>
              </div>
              <div className="card">
                <div className="card-content"><span className="bq">"J'ai perdu la haine que j'avais en moi, je suis tombé amoureux de Sessouma, un gabonais de 10 ans mon aîné."</span>
                  <span className="author"> (J.M. le Pen, pré-retraité)</span></div>
              </div>
              <div className="card">
                <div className="card-content"><span className="bq">"Ma Ginette était saoule, a dansé comme une folle, du coup elle a dormi comme une souche et j'ai pu regarder le porno à la TV."</span>
                  <span className="author"> (Robert, 90 ans, pré-adolescent)</span></div>
              </div>
              <p className="justify">ENCORE UNE SOIRÉE RÉUSSIE GRACE AUX MOUV' YOUR BAUDET !!!! </p>

            </div>

          </div>
        </div>

        <Parallax image="media" alt="Médias"/>

        <div className="row content section white">
          <div className="col s12">
            <div className="">
              <span className="content-title">Histoire</span>


              <p className="justify">
                Tatiana arriva au local de répétition vers 21 h, habillée très sexy. Elle avait pris soin de prendre un
                long
                bain parfumé à la patate douce et au piment oiseau d'Ardin (banlieue chic de Los Angeles). Elle savait
                le
                mélange à la hauteur de la variété du répertoire. Suave mais tonique.<br/><br/>
                Après un court rituel d'embrassades toutes en retenue (23h20), Tatiana dégrafa son caraco-shorty pour
                mieux se
                laisser imprégner par la musique à venir.<br/><br/>
                Les musiciens, pourtant aguerris aux techniques de détournement les plus viles, ne purent réprimer un
                certain
                empressement à monter leurs instruments pour répondre à l'appel du malin. Dès lors, le blitzkrieg
                sonique
                s'abattit sur la frêle damoiselle : Bee Gees, Gwen Stephani, White Stripes, Aznavour, Shantel, Busters,
                Abba,
                David Guetta, Partenaire Particulier, Brel, Lady Gaga, The Ceasars, Taxi Girl, Donna Summer,
                ...<br/><br/>
                Le corps tout entier de Tatiana devint volcan. Une question lui vint : pourquoi n'y a-t-il pas de douche
                installée aux répètes Mouv' Your Baudet ??!! Il est vrai.
                <br/><br/>
                La douzaine de musiciens présents ne put s'empêcher de
                se poser la même question. La fournaise gagnant en intensité, ses doigts longilignes se laissèrent aller
                sur les
                quelques cds éparpillés sur l'étal. "Mouv' Your Baudet - Ibiza Fever 2010", "Highway To Mouv' Your
                Baudet",
                "Mouv' Your Baudet - Live au BaudetLand de Bougon". Le choix était on ne peut plus éclectique. C'est ce
                qu'elle
                aimait chez ces musiciens, ... mi Pierre Perret mi Bob Sinclar.
                <br/><br/>
                Rencontré la veille dans une course aux ânes nocturne d'orientation en appartement, elle savait certes
                l'affriolante troupe experte à la sulfateuse à cuivre, riche de ses expériences passées dans de non
                moins
                aguichantes formations (Rosa Mystica, Marcel Fergu Sons, Crochendo, Famille Duhomard, Chiures de
                Mouches,
                Voiture 4, ...). Avait-elle pour autant préparé judicieusement cette rencontre ?
                <br/><br/>
                Sa body lotion au piment oiseau
                d'Ardin lui paraissait désormais aussi dissuasive que Pan-Pan le lapin chez les Village People. C'est
                sûr, la
                prochaine fois, elle viendra avec des copines ...
                <br/><br/>
                Ne les laissez pas venir toutes seules...
                Abaudez vous !
                <br/><br/>
                La Baudet Team
              </p>
            </div>

          </div>
        </div>


        <Parallax image="news" alt="News"/>

        <BottomNavigation previousText="Accueil" previousLink={ROUTE_HOME} nextText="Prestations" nextLink={ROUTE_PERFORMANCES} />

      </div>
    )

  }
}

Introduction.propTypes = {
  setShowPlayer: PropTypes.func
}

export default Introduction



/** WEBPACK FOOTER **
 ** ./src/components/Introduction/Introduction.jsx
 **/